import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

export interface LiveChatUIWelcomeHeroProps {
  graphic: ReactNode | null;
  title: ReactNode;
  subtitle: ReactNode;
  className?: string;
}

export const LiveChatUIWelcomeHero: FC<LiveChatUIWelcomeHeroProps> = ({
  graphic,
  title,
  subtitle,
  className,
}) => (
  <div
    className={cx(
      "flex flex-col items-center gap-8 px-6 py-8 text-center",
      className
    )}
  >
    {graphic && (
      <div className="h-[72px] w-[72px] overflow-hidden rounded-[14px] border-2 border-solid border-[#F2F2F2] md:h-[100px] md:w-[100px]">
        {graphic}
      </div>
    )}
    <div className="flex flex-col gap-2.5">
      <h2 className="font-secondary m-0 text-[18px] font-semibold leading-[140%] text-black md:text-[40px]">
        {title}
      </h2>
      {subtitle && (
        <p className="font-secondary text-dark-700 m-0 text-sm font-normal leading-[140%] md:text-base">
          {subtitle}
        </p>
      )}
    </div>
  </div>
);
